import institutions from './institutions'
import departments from './departments'
import teachers from './teachers'
import indicators from './indicators'
import periods from './periods'
import plan from './plan'
import documents from './documents'

export default {
  institutions,
  departments,
  teachers,
  indicators,
  periods,
  plan,
  documents,
}
